import styled from 'styled-components';
import { type IAdvancedRichText } from '../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { TitleDivider } from '../../../graphics/divider/style/TitleDivider.tsx';

const QuestionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 6px;
`;
const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* margin-bottom: 6px; */
`;
const RightColTitle = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;
const DescriptionTextSize = styled.div`
  font-size: 16px;
`;

export interface IQuestionTitleProps {
  title?: IAdvancedRichText;
  description?: IAdvancedRichText;
}

/**
 * Parte superiore del Widget  "Quesito" Con il Titolo e la descrizione
 */
export function QuestionTitle(props: IQuestionTitleProps) {
  const { title, description } = props;
  return (
    <QuestionTitleWrapper>
      <RowWrapper>
        {title && (
          <RightColTitle>
            <TitleDivider>
              <RichTextAdvancedRender inline hasCustomFont text={title} />
            </TitleDivider>
          </RightColTitle>
        )}
      </RowWrapper>
      {description && (
        <DescriptionTextSize>
          <RichTextAdvancedRender inline hasCustomFont text={description} />
        </DescriptionTextSize>
      )}
    </QuestionTitleWrapper>
  );
}
